export function isSSG() {
    return typeof window === "undefined"
}